module.exports = __webpack_public_path__ + "img/godfrey_masindi.a26afbf9.png";